<template>
  <div class="planInput-search">
    <div class="inputSearch mr8">
      <lk-dropdown
        style="width: 100%"
        ref="dropdown"
        placement="bottom-start"
        trigger="custom"
        :visible="visible"
        @on-click="onDropDownclick">
        <lk-input
          suffix="ios-search"
          placeholder="商品编码、助记码、通用名称"
          v-model.trim="value"
          ref="search"
          @on-change="onInputChange"
          @on-blur="inputBlur"
          @on-keydown="handleSearchKey"
          @on-focus="onInputChange">
        </lk-input>
        <lk-dropdown-menu slot="list" class="searchList">
          <lk-dropdown-item disabled name='title' >
            <div class="options">
              <span>商品编码</span>
              <span>商品通用名</span>
              <span>规格</span>
              <span>生产厂家</span>
              <span>单位</span>
              <span>产地</span>
              <span>商品名</span>
              <span>批准文号/注册证号</span>
            </div>
          </lk-dropdown-item>
          <lk-dropdown-item v-for="(item, index) in options" :key="index" :name='index' :selected='index===selectedIndex' >
            <div :class="{'options':true,}" >
              <span>{{item.drugSerialCode}}</span>
              <span>{{item.approvedDrugName}}</span>
              <span>{{item.specification}}</span>
              <span>{{item.manufacturer}}</span>
              <span>{{item.drugMinimumPackagingUnit}}</span>
              <span>{{item.countryOfOrigin}}</span>
              <span>{{item.goodsName}}</span>
              <span>{{item.approvalNumber}}</span>
            </div>
          </lk-dropdown-item>
        </lk-dropdown-menu>
      </lk-dropdown>
    </div>
    <p class="error">{{errorMsg}}</p>
  </div>
</template>
<script>
// import hotkeys from 'hotkeys-js';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';

export default {
  name: 'inputSearch',
  props: {
    autoFocus: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
    },
    goodsType: {
      type: Number,
    },
    isScan: {
      type: Number,
      default: 2, // 扫码添加商品 1是 2否
    },
    purchaseType: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: null,
      options: [],
      timer: null,
      isEnter: false,
      errorMsg: '',
    };
  },
  methods: {

    onInputChange() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.getData, 500);
    },
    getData() {
      if (this.value) {
        this.$store.commit('setDisableLoading', true);
        this.errorMsg = '';
        purchase.planGoodsList({
          nameMix: this.value,
          type: this.goodsType,
          isScan: this.isScan,
          purchaseType: this.purchaseType,
          // page: 1,
          // size: 100,
        }).then((res) => {
          if (res.data.status === 200) {
            this.options = [];
            const { list } = res.data.data;
            if (list.length) {
              this.visible = true;
              this.selectedIndex = 0;
              let isExistNum = 0;
              list.forEach((item) => {
                const result = {};
                utils.exchangeTable(item.purchaseMedicine, result);
                utils.exchangeTable(item.medicineInfoVo, result);
                result.onTheWayNum = item.onTheWayNum;
                result.inventoryNum = item.inventoryNum;
                result.lastMonthSaleNum = item.lastMonthSaleNum;
                result.loading = false;
                result.mnemonicCode = item.mnemonicCode;
                if (!this.selectedList.includes(result.medicineId)) {
                  this.options.push(result);
                } else {
                  isExistNum++;
                }
              });

              // 找到的内容在列表中已经存在了
              if (isExistNum === list.length) {
                this.value = '';
                this.visible = false;
                this.errorMsg = '该商品已添加!';
              }

              if (this.options.length === 1 && this.isScan === 1) {
                this.seleced();
              }
            } else {
              if (this.isScan === 1) {
                this.errorMsg = '未找到首营商品！请核实后采购!';
                this.value = '';
              }
              this.visible = false;
            }
          } else {
            this.$Message.error('网络连接失败');
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.options = [];
        this.visible = false;
      }
    },
    onDropDownclick(name) {
      if (this.selectLoading || name === 'title') {
        this.selectLoading = false;
        this.visible = false;
        this.$nextTick(() => {
          this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
        });
      } else {
        this.visible = true;
        this.selectLoading = true;
        if (!isNaN(name)) {
          this.selectedIndex = name;
          this.seleced();
          this.$nextTick(() => {
            this.visible = false;
          });
        }
        setTimeout(() => {
          this.selectLoading = false;
        }, 500);
      }
    },
    inputBlur() {
      this.$nextTick(() => {
        this.visible = false;
      });
    },
    onKeydown() {
    },
    focus() {
      this.$refs.search.focus();
    },
    seleced() {
      this.visible = false;
      this.value = '';
      this.$emit('selected', this.options[this.selectedIndex]);
    },
    handleSearchKey(e) {
      if (this.visible) {
        switch (e.key) {
          case 'ArrowDown':
            (this.selectedIndex < this.options.length - 1) && this.selectedIndex++;

            break;
          case 'ArrowUp': (this.selectedIndex > 0) && this.selectedIndex--;

            break;
          case 'Enter': this.seleced(); this.$emit('on-keydown', e);

            break;
          default: break;
        }
      } else if (e.key === 'Enter') {
        this.isEnter = true;
        this.onInputChange();
      } else {
        this.isEnter = false;
      }
      if (e.key === 'z' && e.ctrlKey) {
        this.$emit('swichKeyDown', e, 'goods0');
      }
    },
  },
  mounted() {
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.search.focus();
      });
    }
  },
};
</script>
<style lang="less">
.inputSearch{
  .ivu-select-dropdown{
    width:984px;
  }
}
</style>
<style lang="less" scoped>
.planInput-search {
  display: flex;
  justify-content: center;
  align-items: center;

  .inputSearch {
    /*width: 256px;*/
    flex: 1 1 auto;
  }

  .isScan {
    flex: 0 1 auto;
    margin-left: 8px;
  }
}
.searchList{
  max-height: 256px;
  overflow: auto;
}
.selected{
  background: #f8f8f8;
}
.options{
  display: flex;
  align-items: center;
  font-size: 12px;
  >span{
    flex-shrink: 0;
    text-align: left;
    word-wrap: none;
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 16px;
    height:18px;
    line-height:18px;
  }
  >span:last-child{
    padding-right: 0;
  }
  >span:nth-child(1){
    padding-left: 0;
    width: 82px;
  }
  >span:nth-child(2){
    width: 142px;
  }
  >span:nth-child(3){
    width: 130px;
  }
  >span:nth-child(4){
    width: 142px;
  }
  >span:nth-child(5){
    width: 62px;
  }
  >span:nth-child(6){
    width: 62px;
  }
  >span:nth-child(7){
    width: 142px;
  }
  >span:nth-child(8){
    width: 192px;
  }
  .textOver{
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
  .error {
    color: #ed4014;
  }
</style>
